// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type Close20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Close20Circle: FC<Close20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-5-8.063L8.063 17 12 13.062 15.938 17 17 15.937 13.062 12 17 8.062 15.937 7 12 10.938 8.062 7 7 8.063 10.938 12 7 15.938Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Close20Circle;
